import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";

import { useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Button,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";

import Autocomplete from "@mui/material/Autocomplete";
import Popper from "@material-ui/core/Popper";

import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";

import { GET_TENANT_DATA_BY_USER } from "../../graphQL/tenant_qry";
import {
  CLIENT_MEMBER_DETAIL,
  EDIT_CLIENT_MEMBER_MUTATION,
} from "../../graphQL/clientMember";
import {
  REFRESH_TOKEN_MUTATION,
  STAFF_MODULE_ACCESS_QUERY,
} from "../../graphQL/user_qry";

import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const PopperMy = function (props) {
  return <Popper {...props} style={styles.popper} placement="bottom-start" />;
};
const styles = theme => ({
  popper: {
    width: "fit-content",
  },
});

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1.5rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
    paddingLeft: 5,
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  autoComStyle: {
    "& .MuiAutocomplete-inputRoot": {
      borderRadius: 10,
    },
  },
}));

function EditMember() {
  const classes = useStyles();
  const navigate = useNavigate();
  const client = useContext(ClientContext);
  const [pathname] = useState(window.location.pathname);
  const [loadContent, setLoadContent] = useState(false);

  const { clientMemberId } = useParams();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [alertMsg, setAlertMsg] = useState([]);
  const [errorMsg, setErrorMsg] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNo: "",
    city: "",
    state: "",
    country: "",
    linkedInURL: "",
  });

  const [firstName, setFirstName] = useState("");
  const [username, setUsername] = useState("");
  const [lastName, setLastName] = useState("");
  const [fullName, setFullName] = useState("");
  const [originalEmail, setOriginalEmail] = useState("");
  const [originalEmailUpdateBy, setOriginalEmailUpdateBy] = useState("");
  const [originalEmailUpdateDate, setOriginalEmailUpdateDate] = useState("");
  const [previousEmail, setPreviousEmail] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [linkedinUrl, setLinkedinUrl] = useState("");

  const [tenantStates, setTenantStates] = useState([]);
  const [tenantCountries, setTenantCountries] = useState([]);
  const [editAccess, setEditAccess] = useState(true);

  const tenantName = localStorage.getItem("tenantName");
  const tenantId = localStorage.getItem("tenantId");

  let tenantUserId = 0;
  if (localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;
  if (localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) clientId = localStorage.getItem("clientId");

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    let newFormat = "-";
    if (day) {
      const dayDate = new Date(day);
      const dayFormat = formatter.formatToParts(dayDate);
      newFormat =
        dayFormat.find(a => a.type == "month").value +
        "/" +
        dayFormat.find(a => a.type == "day").value +
        "/" +
        dayFormat.find(a => a.type == "year").value;
    }
    return newFormat;
  };

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
    }
  };

  const [getUserTenantData] = useManualQuery(GET_TENANT_DATA_BY_USER);
  const [getClientMemberData] = useManualQuery(CLIENT_MEMBER_DETAIL);
  const [editCLientMember] = useMutation(EDIT_CLIENT_MEMBER_MUTATION);

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module

    const {
      loading: accessDataLoading,
      error: accessDataError,
      data: accessData,
    } = await checkStaffModuleAccess({
      variables: {
        tenantUserId: parseInt(tenantUserId),
        clientId: parseInt(clientId),
        moduleName: "Members",
        modulepageName: "List",
      },
    });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {
      let commonActions = accessData.staffModuleAccess.commonActions.split("|");

      if (commonActions.find(a => a == "Edit")) {
        setEditAccess(true);
      } else setEditAccess(false);
    }

    if (
      accessDataError &&
      accessDataError.graphQLErrors &&
      accessDataError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin`);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  const getMemberData = async () => {
    // Get tenant information
    const {
      loading: tenantDataLoading,
      error: tenantDataError,
      data: tenantData,
    } = await getUserTenantData();

    if (!tenantDataLoading && tenantData && tenantData.getUserTenantData) {
      setTenantStates(tenantData.getUserTenantData.statesList.map(({ name }) => name));
      setTenantCountries(
        tenantData.getUserTenantData.countriesList.map(({ name }) => name),
      );
    }
    if (
      tenantDataError &&
      tenantDataError.graphQLErrors &&
      tenantDataError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin`);
    }

    // Get member information
    const {
      loading: memberDataLoading,
      error: memberDataError,
      data: memberData,
    } = await getClientMemberData({
      variables: { clientMemberId: parseInt(clientMemberId) },
    });

    if (memberData && !memberData.getClientMemberByClientMemberId) {
      navigate(`${project_url}/tenant/dashboard`);
    } else if (
      memberData &&
      memberData.getClientMemberByClientMemberId &&
      memberData.getClientMemberByClientMemberId == null
    ) {
      navigate(`${project_url}/tenant/dashboard`);
    } else if (
      !memberDataLoading &&
      memberData &&
      memberData.getClientMemberByClientMemberId
    ) {
      setLoadContent(true);
      setUsername(memberData.getClientMemberByClientMemberId.applicantId.userId.username);
      setFirstName(
        memberData.getClientMemberByClientMemberId.applicantId.userId.firstName,
      );
      setLastName(memberData.getClientMemberByClientMemberId.applicantId.userId.lastName);
      setPreviousEmail(
        memberData.getClientMemberByClientMemberId.applicantId.userId.email,
      );
      setEmail(memberData.getClientMemberByClientMemberId.applicantId.userId.email);
      setPhoneNo(memberData.getClientMemberByClientMemberId.applicantId.userId.phoneNo);
      setCity(memberData.getClientMemberByClientMemberId.applicantId.userId.city);
      setState(memberData.getClientMemberByClientMemberId.applicantId.userId.state);
      setCountry(memberData.getClientMemberByClientMemberId.applicantId.userId.country);
      setFullName(
        memberData.getClientMemberByClientMemberId.applicantId.userId.firstName +
          " " +
          memberData.getClientMemberByClientMemberId.applicantId.userId.lastName,
      );
      setOriginalEmail(
        memberData.getClientMemberByClientMemberId.applicantId.originalEmail,
      );
      setOriginalEmailUpdateBy(
        memberData.getClientMemberByClientMemberId.applicantId.originalEmailUpdateBy,
      );
      setOriginalEmailUpdateDate(
        memberData.getClientMemberByClientMemberId.applicantId.originalEmailUpdateDate,
      );
      setLinkedinUrl(
        memberData.getClientMemberByClientMemberId.applicantId.userId.linkedinUrl,
      );
    }

    if (
      memberDataError &&
      memberDataError.graphQLErrors &&
      memberDataError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin`);
    }
  };

  useEffect(() => {
    (() => getMemberData())();
  }, [clientMemberId]);

  const handleFirstNameChange = e => {
    setFirstName(e.target.value);
    if (e.target.value.toString().trim() === "") {
      setErrorMsg({ ...errorMsg, firstName: "First Name cannot be blank." });
    } else {
      setErrorMsg({ ...errorMsg, firstName: "" });
    }
  };

  const handleLastNameChange = e => {
    setLastName(e.target.value);
    if (e.target.value.toString().trim() === "") {
      setErrorMsg({ ...errorMsg, lastName: "Last Name cannot be blank." });
    } else {
      setErrorMsg({ ...errorMsg, lastName: "" });
    }
  };

  const handleEmailChange = e => {
    let newVal = e.target.value;
    setEmail(newVal);
    const validEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (newVal.toString().trim() === "") {
      setErrorMsg({ ...errorMsg, email: "Email address cannot be blank." });
    } else if (!validEmail.test(newVal)) {
      setErrorMsg({ ...errorMsg, email: "Invalid email format." });
    } else {
      setErrorMsg({ ...errorMsg, email: "" });
    }
  };

  const handleLinkedInChange = e => {
    let newVal = e.target.value;
    setLinkedinUrl(newVal);

    if (newVal.toString().trim() === "") {
      setErrorMsg({ ...errorMsg, linkedInURL: "LinkedIn URL cannot be blank." });
    } else {
      setErrorMsg({ ...errorMsg, linkedInURL: "" });
    }
  };

  const handlePhoneChange = e => {
    let newVal = e.target.value;
    setPhoneNo(newVal);
    const validPhoneNo = /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/;

    if (newVal.trim() === "") {
      setErrorMsg({ ...errorMsg, phoneNo: "Phone number cannot be blank." });
    } else if (!validPhoneNo.test(newVal)) {
      setErrorMsg({ ...errorMsg, phoneNo: "Invalid phone number format." });
    } else {
      setErrorMsg({ ...errorMsg, phoneNo: "" });
    }
  };

  const handleCityChange = e => {
    setCity(e.target.value);
    if (e.target.value.toString().trim() === "") {
      setErrorMsg({ ...errorMsg, city: "City cannot be blank." });
    } else {
      setErrorMsg({ ...errorMsg, city: "" });
    }
  };

  const handleStateChange = (event, value) => {
    setState(value);
    if (!value) {
      setErrorMsg({ ...errorMsg, state: "One item must be selected." });
    } else {
      setErrorMsg({ ...errorMsg, state: "" });
    }
  };

  const handleCountryChange = (event, value) => {
    setCountry(value);
    if (!value) {
      setErrorMsg({ ...errorMsg, country: "One item must be selected." });
    } else {
      setErrorMsg({ ...errorMsg, country: "" });
    }
  };

  const onSubmit = async formData => {
    // Check if any validation error exists
    const hasErrors = Object.values(errorMsg).some(msg => msg && msg.trim() !== "");

    if (hasErrors) {
      return;
    }
    const { data, error } = await editCLientMember({
      variables: {
        clientMemberId: parseInt(clientMemberId),
        username: username,
        firstName: firstName,
        lastName: lastName,
        email: email,
        phoneNo: phoneNo,
        city: city,
        state: state,
        country: country,
        linkedinUrl: linkedinUrl,
      },
    });
    if (error && error.graphQLErrors) {
      if (error.graphQLErrors[0].message.includes("Email already exists!")) {
        setAlertMsg({
          title: "Email Validation",
          msg: "This email address cannot be saved, because it is already used by another resource.",
        });
      } else {
        console.log("Error", error, data);
        setAlertMsg({
          title: "Error",
          msg: "Unfortunately an error occurred.",
        });
      }
    } else if (data && data.editMember) {
      setPreviousEmail(email);
      setEmail(email);
      console.log("Success", data);
      setAlertMsg({
        title: "Success",
        msg: "Member has been successfully updated.",
      });
    }
  };

  const openLinkedIn = () => {
    if (!linkedinUrl?.trim()) return;

    let url = linkedinUrl.trim();

    if (!/^https?:\/\//i.test(url)) {
      url = `https://${url}`;
    }

    try {
      const parsedUrl = new URL(url);

      if (!parsedUrl.hostname.includes("linkedin.com")) {
        alert("Please enter a valid LinkedIn URL.");
        return;
      }

      window.open(parsedUrl.href, "_blank", "noopener,noreferrer");
    } catch {
      alert("Please enter a valid URL.");
    }
  };

  if (loadContent)
    if (editAccess)
      return (
        <div className={classes.root}>
          <Header breadcrumbs={[{ label: fullName, link: null }]} />
          <div className={classes.container}>
            <Box mt={2} mb={2} textAlign="center">
              <Typography variant="body1" style={{ marginBottom: 10 }}>
                Edit Member
              </Typography>
            </Box>
            <Divider />
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid
                container
                spacing={3}
                style={{
                  marginTop: 30,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Grid item xs={4}>
                  <TextField
                    className={classes.textFieldStyle}
                    fullWidth
                    label="First Name *"
                    margin="normal"
                    type="text"
                    variant="outlined"
                    id="firstName"
                    value={firstName}
                    {...register("firstName")}
                    onChange={handleFirstNameChange}
                  />
                  {errorMsg.firstName && (
                    <FormHelperText className={classes.errorStyle} error>
                      {errorMsg.firstName}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    className={classes.textFieldStyle}
                    fullWidth
                    label="Last Name *"
                    margin="normal"
                    name="lastName"
                    type="text"
                    variant="outlined"
                    value={lastName}
                    id="lastName"
                    {...register("lastName")}
                    onChange={handleLastNameChange}
                  />
                  {errorMsg.lastName && (
                    <FormHelperText className={classes.errorStyle} error>
                      {errorMsg.lastName}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    className={classes.textFieldStyle}
                    fullWidth
                    label="Email *"
                    margin="normal"
                    name="email"
                    type="email"
                    variant="outlined"
                    value={email}
                    id="email"
                    {...register("email")}
                    onChange={handleEmailChange}
                  />
                  {errorMsg.email && (
                    <FormHelperText className={classes.errorStyle} error>
                      {errorMsg.email}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    className={classes.textFieldStyle}
                    fullWidth
                    label="LinkedIn URL *"
                    margin="normal"
                    name="linkedinUrl"
                    type="text"
                    variant="outlined"
                    value={linkedinUrl}
                    id="linkedinUrl"
                    {...register("linkedinUrl")}
                    onChange={handleLinkedInChange}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            onClick={openLinkedIn}
                            disabled={!linkedinUrl || !linkedinUrl.trim()}
                            title={
                              linkedinUrl && linkedinUrl.trim()
                                ? "View LinkedIn page"
                                : "Enter a LinkedIn URL"
                            }
                          >
                            <OpenInNewIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  {errorMsg.linkedInURL && (
                    <FormHelperText className={classes.errorStyle} error>
                      {errorMsg.linkedInURL}
                    </FormHelperText>
                  )}
                </Grid>

                {originalEmail && (
                  <Box
                    pt={2}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: 2,
                      paddingBottom: 1,
                      gap: 2,
                      fontSize: 16,
                    }}
                  >
                    <Typography variant="h3" component="span">
                      Original Email: {originalEmail}( Updated By: {originalEmailUpdateBy}{" "}
                      -{" "}
                      {dayFormat(originalEmailUpdateDate.substring(0, 10), "monthDDYYYY")}{" "}
                      )
                    </Typography>
                  </Box>
                )}

                <Grid item xs={4}>
                  <TextField
                    className={classes.textFieldStyle}
                    fullWidth
                    label="Phone Number *"
                    margin="normal"
                    name="phoneNo"
                    type="text"
                    variant="outlined"
                    value={phoneNo}
                    id="phoneNo"
                    {...register("phoneNo")}
                    onChange={handlePhoneChange}
                  />
                  {errorMsg.phoneNo && (
                    <FormHelperText className={classes.errorStyle} error>
                      {errorMsg.phoneNo}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    className={classes.textFieldStyle}
                    fullWidth
                    label="City *"
                    margin="normal"
                    name="city"
                    type="text"
                    variant="outlined"
                    value={city}
                    id="city"
                    {...register("city")}
                    onChange={handleCityChange}
                  />
                  {errorMsg.city && (
                    <FormHelperText className={classes.errorStyle} error>
                      {errorMsg.city}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <form noValidate autoComplete="off">
                    <Autocomplete
                      className={classes.autoComStyle}
                      //key={selectedVal}
                      value={state}
                      options={tenantStates}
                      PopperComponent={PopperMy}
                      getOptionLabel={option => (option ? option : "")}
                      onChange={handleStateChange}
                      renderInput={params => (
                        <TextField
                          label="State *"
                          margin="normal"
                          name="selectOptions"
                          variant="outlined"
                          {...params}
                          id="state"
                          {...register("state")}
                        />
                      )}
                    />
                    {errorMsg.state && (
                      <FormHelperText className={classes.errorStyle} error>
                        {errorMsg.state}
                      </FormHelperText>
                    )}
                  </form>
                </Grid>
                <Grid item xs={4}>
                  <form noValidate autoComplete="off">
                    <Autocomplete
                      className={classes.autoComStyle}
                      //key={selectedVal}
                      value={country}
                      options={tenantCountries}
                      PopperComponent={PopperMy}
                      getOptionLabel={option => (option ? option : "")}
                      onChange={handleCountryChange}
                      renderInput={params => (
                        <TextField
                          label="Country *"
                          margin="normal"
                          name="selectOptions"
                          variant="outlined"
                          {...params}
                          id="country"
                          {...register("country")}
                        />
                      )}
                    />
                    {errorMsg.country && (
                      <FormHelperText className={classes.errorStyle} error>
                        {errorMsg.country}
                      </FormHelperText>
                    )}
                  </form>
                </Grid>
              </Grid>

              <Box pt={4} pb={2}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.buttonStyle}
                  style={{ marginRight: 2 }}
                  type="submit"
                >
                  Save
                </Button>

                <Button
                  variant="text"
                  color="primary"
                  className={classes.outlinedButtonStyle}
                  onClick={() => navigate(`${project_url}/members`)}
                >
                  Cancel
                </Button>
              </Box>
            </form>
            {alertMsg.msg && (
              <AlertDialog
                title={alertMsg.title}
                contentMsg={alertMsg.msg}
                closeDialog={() => {
                  setAlertMsg([]);
                  alertMsg.title === "Success" && navigate(`${project_url}/members`);
                  alertMsg.title === "Email Validation" && setEmail(previousEmail);
                }}
              />
            )}
          </div>
        </div>
      );
    else
      return (
        <div className={classes.root}>
          <div className={classes.container}>
            <AlertDialog
              title="No Permission"
              contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.'
              closeDialog={() => {
                navigate(`${project_url}/tenant/dashboard`);
              }}
            />
          </div>
        </div>
      );
  else return;
}

export default EditMember;
